import { render } from "./StepWizard1.vue?vue&type=template&id=9126c58a"
import script from "./StepWizard1.vue?vue&type=script&lang=js"
export * from "./StepWizard1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__